<template>
  <div class="w-full grid grid-cols-3 gap-8">
    <button class="bg-[#fafafa] !text-black text-opacity-90 rounded-lg shadow-lg cursor-default">
      <div class="p-4 flex space-x-1 justify-center w-full flex-1 items-start">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">Talk to a WriteWise Support Advisor.</div>
        </v-tooltip>
        <span class="text-center">Contact Us</span>
      </div>

      <hr class="border-grey" />

      <div class="p-5 flex flex-col items-center">
        <span class="text-center text-xs text-grey text-opacity-10"
          >Talk to a WriteWise Support Advisor</span
        >
      </div>

      <hr class="border-grey" />

      <div class="p-3 flex items-center justify-center w-full">
        <v-btn
          @click="openContactUs()"
          variant="flat"
          class="!py-3 !bg-primary-main !rounded-xl !tracking-normal !capitalize !text-white !h-auto"
        >
          <template v-slot:prepend>
            <Icon icon="ant-design:customer-service" class="text-xl" />
          </template>
          Get Help
        </v-btn>
      </div>
    </button>
    <button
      class="bg-[#fafafa] !text-black text-opacity-90 rounded-lg shadow-lg cursor-default"
    >
      <div class="p-4 flex space-x-1 justify-center w-full flex-1 items-start">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">Collection of the most asked questions using WriteWise.</div>
        </v-tooltip>
        <span class="text-center">FAQ</span>
      </div>

      <hr class="border-grey" />

      <div class="p-5 flex flex-col items-center">
        <span class="text-center text-xs text-grey text-opacity-10"
          >Collection of the most asked questions using WriteWise</span
        >
      </div>

      <hr class="border-grey" />

      <div class="p-3 flex items-center justify-center w-full">
        <v-btn
          @click="openFaq()"
          variant="flat"
          class="!py-3 !bg-primary-main !rounded-xl !tracking-normal !capitalize !text-white !h-auto"
        >
          <template v-slot:prepend>
            <Icon icon="ant-design:link" class="text-xl" />
          </template>
          Explore FAQs
        </v-btn>
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { Icon } from '@iconify/vue';
import contenteditable from 'vue-contenteditable';
import { Watch } from 'vue-property-decorator';

@Options({
  components: {
    Icon,
    contenteditable
  }
})
export default class Support extends Vue {
  public openContactUs() {
    (window.open(process.env.WEB_BASE_URL+'/contact-writewise/', '_blank') as any).focus();
  }

  public openFaq() {
    (window.open(process.env.WEB_BASE_URL+'/software-faq/', '_blank') as any).focus();
  }

  public onClickEdit(e: any) {
    // console.log(e)
  }
}
</script>
